// extracted by mini-css-extract-plugin
export default {"modalFooter":"notifer-modal_modalFooter__JJS4U","footerButton":"notifer-modal_footerButton__I1sfK","modalRoot":"notifer-modal_modalRoot__HbiwB"};